import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSimCard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sim-card-1"} maskId="square-filled-radius-0-stroke-1-IconSimCard1"><path d="M9 17V12H15V17H9Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M4 22V2H14.7071L20 7.29289V22H4ZM8 11V18H16V11H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSimCard1;
